export { request, upload } from '@leancloud/adapters-superagent';

var storage = window.localStorage;
var WebSocket = window.WebSocket;
var platformInfo = {
    name: "Browser",
};

export { WebSocket, platformInfo, storage };
//# sourceMappingURL=index.es.js.map



// WEBPACK FOOTER //
// ./node_modules/@leancloud/platform-adapters-browser/lib/index.es.js